module.exports = __webpack_public_path__ + "static/media/loading_box.145b08cb.gif";